import React from 'react';
import { Stack, Button } from "@chakra-ui/react";
import { useLanguage } from './languageContext';

const UploadDataButton = ({ dataRows, UploadDocument, handleConvertToCSV }) => {
  const { language } = useLanguage();

  return (
    <Stack
      direction={{ base: "column", md: "row" }}
      spacing="24px"
      align="center"
    >
      <Button type="submit" colorScheme="green" mt={4}>
        {language === "english" ? "Show Data" : "Mostrar Datos"}
      </Button>
      {dataRows.length > 0 && (
        <Button
          onClick={UploadDocument}
          colorScheme="linkedin"
          mt={4}
        >
          {language === "english" ? "Submit Data" : "Enviar Datos"}
        </Button>
      )}
      {dataRows.length > 0 && (
        <Button
          onClick={handleConvertToCSV}
          colorScheme="blue"
          mt={4}
        >
          {language === "english" ? "Download Excel File" : "Descargar Archivo de Excel"}
        </Button>
      )}
    </Stack>
  );
};

export default UploadDataButton;